import {
    fontStyles,
    overlayStyles,
    panelStyles,
    textStyles,
} from '../util/themeStyles.js'

/**
 * The styles every profile panel needs, derived from the theme it's given.
 *
 * Each of the three panels behind `/profile/:id` is a route component, so the
 * shell can't hand them computed styles as props without listing five of them
 * per panel and keeping the lists in step. It hands down one `theme` and this
 * derives the rest — see `util/themeStyles.js` for why the derivations
 * themselves aren't in here.
 *
 * A panel that needs more than these (the profile card's shape, the header
 * architecture) imports those directly. They're Overview's alone, and putting
 * them here would mean Stats and Customize computing card geometry they never
 * render.
 */
export default {
    props: {
        /**
         * The resolved theme object from `globals/profiles.js` — the whole
         * thing, not an id. The shell already had to resolve it to paint the
         * page around the panel, and resolving it twice is how the panel and
         * its frame end up disagreeing during a theme change.
         */
        theme: { type: Object, required: true },
    },
    computed: {
        panelStyles() { return panelStyles(this.theme) },
        overlayStyles() { return overlayStyles(this.theme) },
        themeFontStyles() { return fontStyles(this.theme) },
        themeTextStyles() { return textStyles(this.theme) },
    },
}
